// Base URL for the Maren backend API. Set NEXT_PUBLIC_API_URL at build
// time in production; development falls back to localhost:8080 so
// `npm run dev` against a local uvicorn works without any env setup.
//
// Trailing slash is stripped so callers can always write `${API_BASE}/path`.
export const API_BASE = (
  process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:8080"
).replace(/\/+$/, "");
